

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '用户ID',
    },
    {
      key: 'realname',
      dataIndex: 'realname',
      title: '姓名',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '手机号',
    },
    {
      key: 'rights',
      dataIndex: 'rights',
      title: '权限',
      slot: 'rights',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '编辑',
      width: 100,
      slot: 'operate',
      fixed: 'right',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
